import React from 'react';
import NotFoundMessage from "./messages/NotFound";

const NotFound = props => {
    return (
        <NotFoundMessage />
    );
}

export default NotFound;